import React from "react"

import {hasProperty, formatText} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import ViewEntity from "./ViewEntity";
import ViewRelationship from "./ViewRelationship";

class ViewClass extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            noLinks: false,
        };


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.data = {};
        this.data.Class = null;

        if (this.props.Class){
            this.data.Class = this.props.Class; 
        }

        if (this.props.noLinks){
            this.state.noLinks = this.props.noLinks;
        }

        this.filters = {};

        this.columns = {
        };

        this.data.id = null;
        if (this.props.id){
            this.data.id = this.props.id; 
        }


    }

    componentDidMount() {

        if (this.data.Class){
            this.setState({"isLoaded":true});
            return;
        }

    };

    view(json){

        if (json){
            return(
                <PD.Table className="panel">
                    <PD.Tbody>                                

                        {hasProperty(json,'name') &&
                            <PD.Tr>                                
                                <PD.Th>Name</PD.Th>
                                <PD.Td>
                                    {(() => {
                                        switch (this.state.noLinks) {
                                            case true:
                                                return json.name
                                            default:
                                                return (
                                                    <PD.PdNavLink to={"/class/" + json._id} >
                                                        {json.name}
                                                    </PD.PdNavLink>
                                                )
                                        }
                                    })()}
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'type') &&
                            <>
                                <PD.Tr>
                                    <PD.Th>Source Type</PD.Th><PD.Td>{json.sourceType}</PD.Td>
                                </PD.Tr>
                                {json.type=='entity' && json.Entity &&
                                    <PD.Tr>
                                        <PD.Th>
                                            Entity
                                        </PD.Th>
                                        <PD.Td>
                                            <ViewEntity Entity={json.Entity}/>
                                        </PD.Td>
                                    </PD.Tr>
                                }
                                {json.type=='relationship' && json.Relationship &&
                                    <PD.Tr>
                                        <PD.Th>
                                            Relationship
                                        </PD.Th>
                                        <PD.Td>
                                            <ViewRelationship Relationship={json.Relationship}/>
                                        </PD.Td>
                                    </PD.Tr>
                                }

                            </>
                        }
                        
                        {hasProperty(json,'description') &&
                            <PD.Tr>
                                <PD.Th>Description</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.description}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'proposals') &&
                            <PD.Tr>
                                <PD.Th>Proposals</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.proposals}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'DataSpec') &&
                            <>
                                <PD.Tr>                                
                                    <PD.Th>Data Spec</PD.Th>
                                    <PD.Td>    
                                        <PD.PdNavLink to={"/dataspec/" + json.DataSpec._id} > {json.DataSpec.name}</PD.PdNavLink>
                                    </PD.Td>
                                </PD.Tr>

                                {json.DataSpec.Owner &&
                                    <PD.Tr>
                                        <PD.Th>Owner</PD.Th><PD.Td>{json.DataSpec.Owner.organisation}</PD.Td>
                                    </PD.Tr>
                                }
                            </>

                        }


                    </PD.Tbody>
                </PD.Table>
            )
        };
        return null;
    };

    render() {

        if (this.state.isLoaded) {

            return (
                <div>
                    {this.view(this.data.Class)}
                </div>
            )
        }
        else {
            return <div />;
        }

    };    
};
        
export default ViewClass;